/* eslint-disable max-classes-per-file */
import { IdName } from 'src/app/shared/models/id-name';
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';

export class LoadProjects {
  static readonly type = '[Project] Load Projects';
  constructor(public filter?: MainTableFilterModel) {}
}

export class CreateProject {
  static readonly type = '[Project] Create Project';
  constructor(public project: Omit<IdName, 'id'>) {}
}

export class LoadProjectById {
  static readonly type = '[Project] Load Project By Id';
  constructor(public id: string) {}
}

export class UpdateProject {
  static readonly type = '[Project] Update Project';
  constructor(public project: IdName) {}
}

export class DeleteProject {
  static readonly type = '[Project] Delete Project';
  constructor(public id: string) {}
}

export class UpdateProjectStatus {
  static readonly type = '[Project] Update Project Status';
  constructor(
    public projectId: string,
    public status: number
  ) {}
}

export class AssignMaintenanceJobsToProject {
  static readonly type = '[Project] Assign Maintenance Jobs To Project';
  constructor(
    public projectId: string,
    public maintenanceJobIds: string[]
  ) {}
}

export class RemoveMaintenanceJobsFromProject {
  static readonly type = '[Project] Remove Maintenance Jobs From Project';
  constructor(
    public projectId: string,
    public maintenanceJobIds: string[]
  ) {}
}

export class ClearCurrentProject {
  static readonly type = '[Project] Clear Current Project';
}

export class ExportProjectToMarineManager {
  static readonly type = '[Project] Export Project To Marine Manager';
  constructor(public projectId: string) {}
}

export class SyncProjectWithMarineManager {
  static readonly type = '[Project] Sync Project With Marine Manager';
  constructor(public projectId: string) {}
}

export class SyncLinkWithMarineManager {
  static readonly type = '[Project] Sync Link With Marine Manager';
  constructor(
    public projectId: string,
    public linkId: string
  ) {}
}

export class CompleteProject {
  static readonly type = '[Project] Complete Project';
  constructor(public projectId: string) {}
}

export class LoadProjectExportErrors {
  static readonly type = '[Project] Load Project Export Errors';
  constructor(public projectId: string) {}
}
